import { css, SerializedStyles, Theme } from "@emotion/react"

export const unitStyle = (theme: Theme): SerializedStyles => css`
	font-weight: 500;
	margin-left: 1rem;
	margin-right: 0.5rem;
	width: 2.8rem;

	${theme.breakpoints.down("xs")} {
		display: none;
	}
`

export const inputStyle = css`
	width: 5.7rem;
	text-align: center;
	color: #111827;

	input,
	select {
		padding: 0.5rem 1rem;
		text-align: center;
	}
`

export const trashCan = (unitOfMeasure: string | null): SerializedStyles => css`
	margin-top: -0.6rem;
	margin-left: ${unitOfMeasure ? 0 : "1rem"};
`

export const quantityLabel = css`
	color: #111827;
	font-size: 1rem;
	font-weight: 700;
	margin-right: 1rem;
`

export const quantityControlLabel = css`
	display: flex;
	margin: 0.75rem 0;
`

export const box = css`
	display: flex;
	align-items: center;
`

export const saveIcon = css`
	margin-left: 1rem;
	&:hover {
		cursor: pointer;
	}
`

export const editBox = css`
	position: relative;
	display: flex;
	align-items: center;
`

export const clearText = (theme: Theme): SerializedStyles => css`
	padding: 1rem;
	font-size: 14px;
	color: ${theme.palette.colors.brandCobalt};

	&:hover {
		color: ${theme.palette.colors.brandNavy};
	}
`

export const underlineHoverStyle = css`
	text-decoration: none;
	&:hover {
		text-decoration: underline;
	}
`
